module.exports = __webpack_public_path__ + "img/mt.mt35575a1.svg";